import * as actionTypes from '../redux-actions/redux-actions';

const initialState = {
    ingredients : {
        'salad' : 0,
        'cheese' : 0,
        'meat' : 0,
        'bacon' : 0
    },
    totalPrice : 4
};

const INGREDIENT_PRICE = {
    'salad' : 0.5,
    'cheese' : 0.5,
    'meat' : 2.4,
    'bacon' : 0.6
}

const add = (previousState , actions) => {
    const type = actions.ingredientsType;
    const updatedCount = previousState.ingredients[type];
    const updated = updatedCount + 1;
    let updateIngredients = {...previousState.ingredients};
    updateIngredients[type] = updated;
    const priceTobeAdded = INGREDIENT_PRICE[type];
    const updatedPrice = previousState.totalPrice + priceTobeAdded;
    return {ingredients:updateIngredients,totalPrice:updatedPrice};
}

const remove = (previousState,actions) => {
    const rmtype = actions.ingredientsType;
    const updatedRmCount = previousState.ingredients[rmtype];
    const updatedRm = updatedRmCount? updatedRmCount - 1 : 0;
    let updateRmIngredients = {...previousState.ingredients};
    updateRmIngredients[rmtype] = updatedRm;
    const priceTobeRemoved = INGREDIENT_PRICE[rmtype];
    const updatedRmPrice = previousState.totalPrice - priceTobeRemoved;
    return {ingredients:updateRmIngredients,totalPrice:updatedRmPrice};
}

const reducerFunc = (previousState = initialState, actions) => {
    // do you actions over here
    switch(actions.type){
        case actionTypes.ADD_INGREDIENTS:
            return add(previousState,actions);
        case actionTypes.REMOVE_INGREDIENTS:
            return remove(previousState,actions);
        default:
            break;
    }
    return previousState;
}

export default reducerFunc;